// import React from "react";
// import "./ukg_offerings.css";
// import ukgImage from "../../img/des_sec/offerings_1.svg";

// function UkgOfferings({openContactModal}) {
//   return (
//     <div className="ukg-exact-container">
//       {/* Centered Heading - Added above the main content */}
//       <h1 className="ukg-exact-main-heading2-centered">Expertise in <span className="ukg-exact-main-heading-centered">Implementing UKG offerings</span> </h1>
      
//       <div className="ukg-exact-content-wrapper">
//         {/* Image Section - Left */}
//         <div className="ukg-exact-image-wrapper">
//           <img src={ukgImage} alt="UKG Implementation" className="ukg-exact-image" />
//         </div>

//         {/* Content Section - Right */}
//         <div className="ukg-exact-content">
//           <h3 className="ukg-exact-section-title">End - End offerings in UKG</h3>
//           <p className="ukg-exact-description">
//             Precision-driven UKG solutions for efficiency, compliance, and growth—seamless implementation, 
//             advanced reporting, and expert support.
//           </p>

//           <div className="ukg-exact-buttons">
//             <button onClick={openContactModal} className="ukg-exact-primary-btn">Talk to an Expert</button>
//             <button onClick={() => (window.location.href = "/services")} className="ukg-exact-secondary-btn">Know More</button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default UkgOfferings;

// import React from "react";
// import "./ukg_offerings.css";
// import ukgImage from "../../img/des_sec/offerings_1.svg";
// import { useSpring, useTrail, animated } from "@react-spring/web";
// import { useInView } from "react-intersection-observer";

// function UkgOfferings({ openContactModal }) {
//   // Detect when component is in view
//   const { ref, inView } = useInView({
//     triggerOnce: false, // Allow animations to replay if component leaves and re-enters viewport
//     threshold: 0.3, // Trigger when 30% of component is visible
//   });

//   // Animation for main heading (fade-in and slide-up)
//   const headingProps = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? "translateY(0)" : "translateY(30px)",
//     config: { tension: 150, friction: 30 }, // Slower, smoother animation
//     delay: 200,
//   });

//   // Animation for image (fade-in and slide-left)
//   const imageProps = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? "translateX(0)" : "translateX(50px)",
//     config: { tension: 150, friction: 30 }, // Slower, smoother animation
//     delay: 400,
//   });

//   // Animation for section title (fade-in and slide-up)
//   const sectionTitleProps = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? "translateY(0)" : "translateY(20px)",
//     config: { tension: 150, friction: 30 }, // Slower, smoother animation
//     delay: 600,
//   });

//   // Animation for description (fade-in and slide-up)
//   const descriptionProps = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? "translateY(0)" : "translateY(20px)",
//     config: { tension: 150, friction: 30 }, // Slower, smoother animation
//     delay: 800,
//   });

//   // Animation for buttons (staggered fade-in and scale-up)
//   const buttons = ["Talk to an Expert", "Know More"];
//   const buttonTrail = useTrail(buttons.length, {
//     opacity: inView ? 1 : 0,
//     transform: inView ? "scale(1)" : "scale(0.8)",
//     config: { tension: 150, friction: 30 }, // Slower, smoother staggered effect
//     delay: 1000,
//   });

//   return (
//     <div className="ukg-exact-container" ref={ref}>
//       <animated.h1 className="ukg-exact-main-heading2-centered" style={headingProps}>
//         Expertise in <span className="ukg-exact-main-heading-centered">Implementing UKG offerings</span>
//       </animated.h1>

//       <div className="ukg-exact-content-wrapper">
//         <div className="ukg-exact-image-wrapper">
//           <animated.img
//             src={ukgImage}
//             alt="UKG Implementation"
//             className="ukg-exact-image"
//             style={imageProps}
//           />
//         </div>

//         <div className="ukg-exact-content">
//           <animated.h3 className="ukg-exact-section-title" style={sectionTitleProps}>
//             End - End offerings in UKG
//           </animated.h3>
//           <animated.p className="ukg-exact-description" style={descriptionProps}>
//             Precision-driven UKG solutions for efficiency, compliance, and growth—seamless implementation,
//             advanced reporting, and expert support.
//           </animated.p>

//           <div className="ukg-exact-buttons">
//             {buttonTrail.map((props, index) => (
//               <animated.button
//                 key={index}
//                 onClick={
//                   index === 0
//                     ? openContactModal
//                     : () => (window.location.href = "/services")
//                 }
//                 className={
//                   index === 0 ? "ukg-exact-primary-btn" : "ukg-exact-secondary-btn"
//                 }
//                 style={props}
//               >
//                 {buttons[index]}
//               </animated.button>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default UkgOfferings;

import React from "react";
import "./ukg_offerings.css";
import ukgImage from "../../img/des_sec/offerings_1.svg";
import { useSpring, animated } from "@react-spring/web";
import { useInView } from "react-intersection-observer";

function UkgOfferings({ openContactModal }) {
  // Detect when component is in view
  const { ref, inView } = useInView({
    triggerOnce: false, // Allow animations to replay if component leaves and re-enters viewport
    threshold: 0.3, // Trigger when 30% of component is visible
  });

  // Animation for main heading (fade-in and slide-up, unchanged)
  const headingProps = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? "translateY(0)" : "translateY(30px)",
    config: { tension: 150, friction: 30 },
    delay: 200,
  });

  // Animation for image (fade-in and slide-left, unchanged)
  const imageProps = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? "translateX(0)" : "translateX(50px)",
    config: { tension: 150, friction: 30 },
    delay: 400,
  });

  // Animation for the entire right-side content (fade-in and slide-up)
  const contentProps = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? "translateY(0)" : "translateY(20px)",
    config: { tension: 150, friction: 30 },
    delay: 600,
  });

  return (
    <div className="ukg-exact-container" ref={ref}>
      <animated.h1 className="ukg-exact-main-heading2-centered" style={headingProps}>
        Expertise in <span className="ukg-exact-main-heading-centered">Implementing UKG offerings</span>
      </animated.h1>

      <div className="ukg-exact-content-wrapper">
        <div className="ukg-exact-image-wrapper">
          <animated.img
            src={ukgImage}
            alt="UKG Implementation"
            className="ukg-exact-image"
            style={imageProps}
          />
        </div>

        <animated.div className="ukg-exact-content" style={contentProps}>
          <h3 className="ukg-exact-section-title">
            End - End offerings in UKG
          </h3>
          <p className="ukg-exact-description">
            Precision-driven UKG solutions for efficiency, compliance, and growth—seamless implementation,
            advanced reporting, and expert support.
          </p>
          <div className="ukg-exact-buttons">
            <button
              onClick={openContactModal}
              className="ukg-exact-primary-btn"
            >
              Talk to an Expert
            </button>
            <button
              onClick={() => (window.location.href = "/services")}
              className="ukg-exact-secondary-btn"
            >
              Know More
            </button>
          </div>
        </animated.div>
      </div>
    </div>
  );
}

export default UkgOfferings;